import ApiService from './ApiService';

const TeamService = {
  team: () => ApiService.get('/team'),
  createTeam: (template) => ApiService.post('/teams', { template }),
  createBot: (groupId, bot) => ApiService.post(`/groups/${groupId}/bots`, bot),
  updateBot: (botId, fields) => ApiService.patch(`/bots/${botId}`, fields),
  catalog: () => ApiService.get('/tools/catalog'),
};

export default TeamService;
